import { stringify } from 'querystring'

export default class {
    constructor(params) {
        this.setting = Object.assign({}, this.defaults(), params)

        this.setting.baseDom = document.querySelector(this.setting.targetSelector)

        this.setting.inputDom = this.setting.baseDom.querySelector(this.setting.addTagSelector)

        this.setting.addDom = this.setting.inputDom.closest('div')

        this.setting.tagListDom = this.setting.baseDom.querySelector(this.setting.tagListSelector)

        let inputTimeoutId
        this.setting.inputDom.addEventListener('keyup', e => {
            let keyword = e.currentTarget.value
            clearTimeout(inputTimeoutId)

            inputTimeoutId = setTimeout(async () => {
                let beforeDom = this.setting.addDom.querySelector(`.${this.setting.suggestClass}`)
                if(beforeDom){
                beforeDom.parentNode.removeChild(beforeDom)
                }
                if (!keyword) return

                let suggest = document.createElement('div')
                suggest.classList.add(this.setting.suggestClass)
                this.setting.addDom.appendChild(suggest)

                let bodyStringify = stringify(Object.assign({}, this.setting.addValues, {
                    keyword,
                    limit: this.setting.searchLimitCnt,
                }))
                let resp = await this.fetchJson(`${this.setting.searchPath}?${bodyStringify}`, {
                    method: 'GET',
                    credentials: 'same-origin',
                })
                if(this.setting.tmpList == resp.tags){
                    return
                }
                this.setting.tmpList = [...resp.tags]
                this.renderSearchList(suggest, resp.tags)
            }, 400)
        })

        document.querySelector(`#${this.setting.addTagFormId}`).addEventListener('submit', e => {
            let value = this.setting.inputDom.value
            if (value) {
                this.addTag(null, value)
            }
            e.stopPropagation()
            e.preventDefault()
        })

        for(const elm of this.setting.tagListDom.children){
            this.deleteTag(elm)
        }
    }

    defaults() {
        return {
            targetSelector: '#input-tags',
            tagListSelector: '.tag-list',
            addTagSelector: '.input',
            addTagFormId: 'addTagForm',
            suggestClass: 'suggest',
            searchPath: '/tag/search',
            searchLimitCnt: 5,
            //addPath: '/editor/tag',
            fetchSetup: {},
            addValues: {},
        }
    }
    renderSearchList(target, tags) {
        if (!tags.length) return
        let ulDom = document.createElement('ul')
        tags.forEach((_tag) => {
            let liDom = document.createElement('li')
            liDom.setAttribute('data-id', _tag.id)
            liDom.textContent = _tag.name

            ulDom.appendChild(liDom)

            liDom.addEventListener('click', e => {
                let id = e.currentTarget.getAttribute('data-id')
                let name = e.currentTarget.textContent
                this.addTag(id, name)
                let beforeDom = this.setting.addDom.querySelector(`.${this.setting.suggestClass}`)
                if(beforeDom){
                beforeDom.parentNode.removeChild(beforeDom)
                }
            })
        })
        target.appendChild(ulDom)
    }

    addTag(id, name) {
        this.setting.inputDom.value = ''
        let target = this.setting.tagListDom
        let addDom = document.createElement('label')
        let chkObj = document.createElement('input')
        chkObj.type = 'checkbox'
        chkObj.name = 'tag[]'
        chkObj.value = name
        chkObj.checked = true

        let nameObj = document.createElement('p')
        nameObj.textContent = name

        let deleteObj = document.createElement('span')
        deleteObj.classList.add('delete')

        addDom.appendChild(chkObj)
        addDom.appendChild(nameObj)
        addDom.appendChild(deleteObj)

        target.appendChild(addDom)

        this.deleteTag(addDom)
    }

    deleteTag(obj){
        obj.querySelector('.delete').addEventListener('click', e => {
            obj.parentNode.removeChild(obj)
        })
    }

    prepend(target, dom) {
        target.parentNode.insertBefore(dom, target.parentNode.firstElementChild);
    }

    async fetchJson(path, params) {
        let send = {
            credentials: 'same-origin',
        }
        Object.assign(send, this.setting.fetchSetup, params)

        let resp = await fetch(path, send)
        return resp.json()
    }
}
